import * as React from 'react';
import hookdWhiteLogo from '../../static/hookdwhitelogo.png';
import { Component, deps, inject, observer } from '../../lib/component';
import {AppHeader} from '../app-header';

@inject(deps) @observer
export class Header extends Component<{}> {
  render() {
    const basket = this.props.model.basket;

    const { firstPaint, isMobile, solidHeader, showSearchDrawer, showMenuDrawer, showSignUpCTA } = this.props.model.ui;
    const { youtubeLoginURL } = this.props.model.auth;
    const { user, channel } = this.props.model.user;
    const { pathname } = this.props.model.router.location;

    return (
      <AppHeader
        showMenu={showMenuDrawer}
        solid={solidHeader}
        shunted={showSignUpCTA}
        basket={basket}
        user={user}
        channel={channel}
        logoImage={hookdWhiteLogo}
        accountURI={user ? '/account' : youtubeLoginURL}
        onClickSignIn={this.handleClickSignIn}
        onClickSignOut={this.handleClickSignOut}
        onClickLink={this.handleClickLink}
        onClickMenu={this.handleClickMenu}
        onClickClose={this.handleClickClose}
        activePath={pathname}
      />
    );
  }

  handleClickSignIn = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.onboarding.openSignUpModal();
  };

  handleClickSignOut = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.auth.logout();
  };

  handleClickLink = (event: React.MouseEvent<any>) => {
    const el = event.currentTarget as HTMLAnchorElement;
    switch (el.pathname) {
      case '/':
        this.props.controller.page.home.reset();
        this.redirect(event, el.pathname);
        break;
      case '/browse':
          this.props.controller.analytics.sendMixpanel("User clicks browse")
          this.redirect(event, el.pathname)
        break;
      case '/search':
        this.props.controller.analytics.sendMixpanel("User clicks search")
        this.redirect(event, el.pathname)
        break;
      case '/checkout':
        this.props.controller.analytics.sendMixpanel("Clicked basket");
        this.redirect(event, el.pathname);
        break;
      case '/account':
        this.handleClickAccount(event);
        break;
      case '/favourites':
        if (this.props.model.user.user) {
          this.redirect(event, el.pathname)
        } else {
          this.handleClickSignIn(event);
        }
        break;
      default:
        this.redirect(event, el.pathname);
        break;
    }
  };

  handleClickMenu = (event: React.MouseEvent<any>) => {
    this.props.controller.ui.setMenuDrawer(!this.props.model.ui.showMenuDrawer);
  };

  handleClickClose = (event: React.MouseEvent<any>) => {
    this.props.controller.ui.setMenuDrawer(false);
  };

  redirect = (event: React.MouseEvent<any>, pathname: string) => {
    event.preventDefault();
    event.stopPropagation();
    this.handleClickClose(event);
    this.props.model.router.push(pathname);
  };

  handleClickAccount = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.controller.ui.setAccountPopover(
      !this.props.model.ui.showAccountPopover
    );
  };
}